import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import PhonesPhoto from '../../assets/images/Berlin-iPhone-B.png'; // Update with your actual path

const Block4 = () => {
    return (
        <Box
            sx={{
                // p: 4
                p: { xs: 4, sm: 15 },
            }}
        >
            <Stack
                direction={{ xs: 'column', sm: 'row' }} // Responsive: column for mobile, row for desktop
                alignItems="center"
                spacing={4}
                sx={{
                    justifyContent: 'space-between',
                    flexWrap: 'wrap', // Ensure proper wrapping for smaller screens
                }}
            >
                {/* Text Content */}
                <Box
                    sx={{
                        flex: 1,
                        textAlign: { xs: 'left', sm: 'left' }, // Center for mobile, left for desktop
                        maxWidth: { sm: '50%' },
                    }}
                >
                    {/* Phase 1 */}
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 500,
                            color: '#dc5454',
                            fontSize: { xs: '1.2rem', sm: '2rem' },
                            mb: 2,
                        }}
                    >
                        Move Beyond Inspiration
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: "justify",
                            fontSize: { xs: '1rem', sm: '1.15rem' },
                            maxWidth: { xs: '100%', sm: '75%' },
                            mb: 4,
                        }}
                    >
                        Travyx revolutionizes travel planning with proprietary AI that creates
                        end-to-end trips tailored to each traveler’s preferences. Our platform empowers
                        users to effortlessly build personalized itineraries while delivering
                        unforgettable vacation experiences with ease.
                    </Typography>
                </Box>

                {/* PNG Image */}
                <Box
                    component="img"
                    src={PhonesPhoto}
                    alt="Illustration"
                    draggable="false"
                    sx={{
                        flex: 1,
                        width: { xs: '85%', sm: '50%' }, // 85% width on mobile, 50% width on desktop
                        maxWidth: '480px',
                    }}
                />
            </Stack>
        </Box>
    );
};

export default Block4;
